import React from 'react';
import { formatFileSize, getFileColor } from '../../utils';
import type { Content } from '../../types/uploader';

interface FileItemProps {
  file: Content;
}

const FileItem = (props: FileItemProps) => {
  const { file } = props;

  const type = file.url.split('.').pop();

  return (
    <div
      className={`flex items-center justify-between px-5 py-4 ${getFileColor(type as string)} rounded-xl`}
    >
      <div className='flex items-center gap-10'>
        <div className='text-lg font-heading font-medium leading-[1.5rem]'>
          {type?.toUpperCase()}
        </div>
        <div>
          <p className='text-sm mb-0 font-bold'>{file.key.split('-').pop()}</p>
          {file.size ? (
            <p className='text-sm mb-0'>{formatFileSize(file.size)}</p>
          ) : (
            ''
          )}
        </div>
      </div>
    </div>
  );
};

export default FileItem;
